import { Col, Container, Row } from "reactstrap";
import { FooterDescription, FooterDetailData } from "../../../data/layout/Footer";
import UsePathName from "../../../utils/UsePathName";
import FooterInfo from "../common/FooterInfo";
import FooterBranding from "../common/FooterBranding";
import FooterContacts from "./FooterContacts";

const FooterDemo1 = () => {
  const [Path] = UsePathName();

  const FooterData = FooterDetailData.filter(({ id }) => [1, 2, 3, 4].includes(id));
  return (
    <footer className={`property-footer-section ${Path?.includes("job") ? "job-footer-section" : ""}`}>
      <Container>
        <FooterContacts />
        <div className="dark-job-footer">
          <Row className="gy-4">
            <Col lg="3" xs="12">
              <FooterBranding description={FooterDescription[0]} endPoint={3} />
            </Col>
            <Col lg="9" xs="12">
              <Row className="gy-lg-4 gy-3">
                <FooterInfo data={FooterData} footerMenu />
              </Row>
            </Col>
          </Row>
        </div>
        <div className="copyright">
          <p>@ 2025 All Rights Reserved</p>
        </div>
      </Container>
    </footer>
  );
};

export default FooterDemo1;
